import { useEffect, useRef } from "react";

/**
 * Prevents window scrolling while preserving scroll position when released.
 * Uses `position: fixed` on `body` so engines that scroll `html` (e.g. Firefox) still lock.
 */
export default function useBodyScrollLock(locked: boolean) {
  const scrollYRef = useRef(0);

  useEffect(() => {
    if (!locked) return;

    const html = document.documentElement;
    const body = document.body;

    scrollYRef.current = window.scrollY;
    const scrollbarGap = window.innerWidth - html.clientWidth;

    html.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.top = `-${scrollYRef.current}px`;
    body.style.left = "0";
    body.style.right = "0";
    body.style.width = "100%";
    // Prevent horizontal layout shift if scrollbar takes up physical space in the viewport
    if (scrollbarGap > 0) {
      body.style.paddingRight = `${scrollbarGap}px`;
    }

    return () => {
      html.style.overflow = "";
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.paddingRight = "";
      window.scrollTo(0, scrollYRef.current);
    };
  }, [locked]);
}
